module.exports = __webpack_public_path__ + "img/lamps.6618bfd7.svg";